import { AsyncActions } from '@telstra-connect/standard-actions/';
import { BILLING_DELETE_PAYMENT_METHODS } from './action-types';
import { IDeletePaymentMethodResponse } from '../state/delete-payment-methods';

export interface IDeletePaymentMethodAction extends AsyncActions.IAsyncFetchableAction
<BILLING_DELETE_PAYMENT_METHODS> {
}

export interface IDeletePaymentMethodSuccessAction extends AsyncActions.IAsyncAction<BILLING_DELETE_PAYMENT_METHODS> {
    data: IDeletePaymentMethodResponse;
}

export type IDeletePaymentMethodErrorAction = AsyncActions.IAsyncErrorAction<BILLING_DELETE_PAYMENT_METHODS>;

export const DeletePaymentMethodStart = (): IDeletePaymentMethodAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: BILLING_DELETE_PAYMENT_METHODS,
    isFetchable: true
});

export const DeletePaymentMethodSuccess = (data: IDeletePaymentMethodResponse): IDeletePaymentMethodSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: BILLING_DELETE_PAYMENT_METHODS,
    data
});

export const DeletePaymentMethodError = (error: string, errorCode: string, errorSubcode: string): IDeletePaymentMethodErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: BILLING_DELETE_PAYMENT_METHODS,
    error,
    errorCode,
    errorSubcode
});

export const DeletePaymentMethodInitial = (): IDeletePaymentMethodAction => ({
    status: AsyncActions.AsyncActionState.NotStarted,
    type: BILLING_DELETE_PAYMENT_METHODS,
    isFetchable: true
});
